import { afterNextRender, Directive, ElementRef, inject, signal } from '@angular/core';

const FOOTER_CLEARANCE_PX = 100;

// Matches the wrapper id in signage-display.component.html; importing it from there would close a cycle back to this file.
const DISPLAY_WRAPPER_ID = 'ds-main-wrapper';

/** Marks a text block that no longer fits above the footer, so the layout can switch to its compact style. */
@Directive({
  selector: '[dsTextOverflow]',
  host: { '[class.content-overflow]': 'overflowing()' }
})
export class TextOverflowDirective {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

  public readonly overflowing = signal(false);

  public constructor() {
    // Measured once, while unstyled: the compact style caps this same element, so re-measuring would flip the answer back.
    afterNextRender(() => this.measure());
  }

  private measure(): void {
    // Scoped to this display: a preview embedded in another app must not measure that app's footer or viewport.
    const display = this.element.nativeElement.closest<HTMLElement>(`#${DISPLAY_WRAPPER_ID}`);
    const available = display?.clientHeight || window.innerHeight;
    const footer = (display ?? document).querySelector('footer')?.getBoundingClientRect()?.height ?? 0;
    const text = this.element.nativeElement.offsetHeight;

    this.overflowing.set(text > available - footer - FOOTER_CLEARANCE_PX);
  }
}
